import { Component, OnInit } from '@angular/core';
import { MapService } from '../leaflet/service/map.service';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';
import { PopoverController, IonFab } from '@ionic/angular';
import { ViewChild, HostListener, ElementRef } from '@angular/core';
import { FloatingMenuService } from '../floating-menu/floating-menu.service';
import { MapLayerSelectorComponent } from '../map-layer-selector/map-layer-selector.component';
import { SigninService } from 'src/app/signin/signin.service';
declare let L;

@Component({
    selector: 'app-map-controls',
    templateUrl: './map-controls.component.html',
    styleUrls: ['./map-controls.component.scss'],
})
export class MapControlsComponent implements OnInit {

    @ViewChild('fab', { static: false }) fab: IonFab;

    markerDrawer: any = null;
    drawingMarker = false;

    constructor(
        public mapService: MapService,
        private geolocation: Geolocation,
        public realTimeWorker: RealtimeWorkerService,
        private popoverCtrl: PopoverController,
        private menuService: FloatingMenuService,
        private eRef: ElementRef,
        public signinService: SigninService
    ) { }

    @HostListener('document:mousedown', ['$event'])
    clickout(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            if (this.fab) this.fab.close();
        }
    }

    ngOnInit() {
        this.menuService.activeMenu$.subscribe(menuId => {
            if (menuId !== 'map' && this.fab) {
                this.fab.close();
            }
        });
    }

    onFabClick() {
        this.menuService.setActiveMenu('map');
    }

    async toggleLayers(event: any) {
        const popover = await this.popoverCtrl.create({
            component: MapLayerSelectorComponent,
            event: event,
            translucent: true,
            cssClass: 'layer-selector-popover'
        });
        return await popover.present();
    }

    togglePOI() {
        if (this.mapService.poisInMap) {
            this.realTimeWorker.removePointInterests();
        } else {
            this.realTimeWorker.drawPointInterests();
        }
    }

    toggleClustering() {
        // Swap between the clustered layer and the individual-markers layer
        // WITHOUT re-initializing the map (re-init wipes the container and
        // all markers, which made the map disappear).
        this.realTimeWorker.getAllRealTimeRecords();
        this.mapService.grouped = !this.mapService.grouped;

        const map = this.mapService.map;
        if (map) {
            if (this.mapService.grouped) {
                if (map.hasLayer(this.mapService.markerclusterIndiv)) {
                    map.removeLayer(this.mapService.markerclusterIndiv);
                }
                if (!map.hasLayer(this.mapService.markercluster)) {
                    map.addLayer(this.mapService.markercluster);
                }
            } else {
                if (map.hasLayer(this.mapService.markercluster)) {
                    map.removeLayer(this.mapService.markercluster);
                }
                if (!map.hasLayer(this.mapService.markerclusterIndiv)) {
                    map.addLayer(this.mapService.markerclusterIndiv);
                }
            }
        }
        localStorage.setItem('groupsView', String(this.mapService.grouped));
    }

    fitBounds() {
        this.mapService.boundAllVehicles();
    }

    centerMe() {
        this.geolocation.getCurrentPosition().then((resp) => {
            if (this.mapService.map) {
                this.mapService.map.setView([resp.coords.latitude, resp.coords.longitude], 15);
            }
        }).catch((error) => {
            console.log('Error getting location', error);
        });
    }

    drawMarker() {
        if (!this.mapService.map) {
            return;
        }

        if (this.drawingMarker) {
            this.cancelDraw();
            return;
        }

        if (this.fab) {
            this.fab.close();
        }

        this.markerDrawer = new L.Draw.Marker(this.mapService.map, {
            icon: this.buildPoiPinIcon()
        });

        this.mapService.map.once(L.Draw.Event.DRAWSTOP, () => {
            this.drawingMarker = false;
            this.markerDrawer = null;
        });

        this.markerDrawer.enable();
        this.drawingMarker = true;
    }

    cancelDraw() {
        if (this.markerDrawer) {
            this.markerDrawer.disable();
            this.markerDrawer = null;
        }
        this.drawingMarker = false;
    }

    confirmDrawPosition() {
        if (!this.mapService.map) {
            return;
        }
        const center = this.mapService.map.getCenter();
        this.cancelDraw();
        void this.mapService.addPoiPopover(center.lat, center.lng);
    }

    /** Modern CSS pin (no image asset needed, so it can never appear broken). */
    private buildPoiPinIcon() {
        return L.divIcon({
            className: 'poi-draw-pin',
            html: `
              <div style="position:relative;width:34px;height:44px;">
                <div style="position:absolute;left:2px;top:2px;width:30px;height:30px;
                            background:linear-gradient(145deg,#4d8dff,#2f66d0);
                            border:2px solid #ffffff;border-radius:50% 50% 50% 0;
                            transform:rotate(-45deg);
                            box-shadow:0 4px 10px rgba(0,0,0,0.35);"></div>
                <div style="position:absolute;left:12px;top:11px;width:10px;height:10px;
                            background:#ffffff;border-radius:50%;"></div>
                <div style="position:absolute;left:11px;bottom:0;width:12px;height:4px;
                            background:rgba(0,0,0,0.25);border-radius:50%;"></div>
              </div>`,
            iconSize: [34, 44],
            iconAnchor: [17, 40],
            popupAnchor: [0, -36]
        });
    }

}
